import { Account, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function editPassword(httpClient: HttpClient) {
  return (
    account: Identifiable<Account>,
    currentPassword: string,
    nextPassword: string,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/api/users/password/change`,
        method: HttpMethods.POST,
        headers: {
          email: account.email,
          old: currentPassword,
          new: nextPassword,
        },
      })
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            wrongPassword: "wrongPassword",
          }),
        ),
      );
}

export { editPassword };
